var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "undo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9809_38728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9809_38728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "undo_2",
    d: "M7.95195 18.4998C7.73912 18.4998 7.56087 18.428 7.4172 18.2843C7.2737 18.1408 7.20195 17.9627 7.20195 17.7498C7.20195 17.537 7.2737 17.3588 7.4172 17.2153C7.56087 17.0717 7.73912 16.9998 7.95195 16.9998H14.3787C15.4224 16.9998 16.3205 16.6552 17.073 15.9661C17.8256 15.2771 18.202 14.4262 18.202 13.4133C18.202 12.4005 17.8256 11.5511 17.073 10.8651C16.3205 10.1792 15.4224 9.83632 14.3787 9.83632H7.3577L9.61345 12.0921C9.75829 12.2371 9.8307 12.4127 9.8307 12.6191C9.8307 12.8254 9.75829 13.0011 9.61345 13.1461C9.46862 13.2909 9.29137 13.3617 9.0817 13.3586C8.87204 13.3552 8.69804 13.2844 8.5597 13.1461L5.1327 9.71907C5.03904 9.6254 4.97304 9.52665 4.9347 9.42282C4.8962 9.31899 4.87695 9.20682 4.87695 9.08632C4.87695 8.96582 4.8962 8.85365 4.9347 8.74982C4.97304 8.64599 5.03904 8.54724 5.1327 8.45357L8.5597 5.02682C8.70454 4.88199 8.88012 4.80957 9.08645 4.80957C9.29295 4.80957 9.46862 4.88199 9.61345 5.02682C9.75829 5.17165 9.82912 5.3489 9.82595 5.55857C9.82279 5.76807 9.75195 5.94207 9.61345 6.08057L7.3577 8.33632H14.3787C15.8415 8.33632 17.0945 8.82449 18.1375 9.80082C19.1805 10.7772 19.702 11.9813 19.702 13.4133C19.702 14.8453 19.1805 16.0511 18.1375 17.0306C17.0945 18.0101 15.8415 18.4998 14.3787 18.4998H7.95195Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.dc137c39c9f28bc13778287161f988aa.svg";
export { ForwardRef as ReactComponent };